import { z } from "zod";

import { DEFAULT_CODE_LENGTH } from "~/common/constants/verificationCode";

export const termsAndConditionsSchema = z.object({
  termsAndConditions: z.boolean().refine((value) => value === true, {
    error: "You must agree to the terms and conditions",
  }),
  guardian_name: z.string().optional(),
});

export const mobileNumberSchema = z.object({
  phoneNumber: z
    .string()
    .min(1, "Mobile number required")
    .regex(/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/, {
      error: "Please enter mobile number with format: (123) 456-7890",
    }),
});

export const mobileNumberVerificationSchema = z.object({
  code: z
    .string({ error: "Verification code is required" })
    .min(6, `${DEFAULT_CODE_LENGTH} character code required`),
});

export const namesAndEmailSchema = z.object({
  name: z
    .string()
    .min(1, "First name is required")
    .max(30, "First name can’t be longer than 30 characters."),
  last_name: z
    .string()
    .min(1, "Last name is required")
    .max(30, "Last name can’t be longer than 30 characters."),
  email: z
    .email({ error: "Please provide a valid email address." })
    .max(70, "Email can’t be longer than 70 characters."),
});

export const teamMemberNamesAndEmailSchema = z.object({
  name: z.string().min(1, "First name is required"),
  last_name: z.string().min(1, "Last name is required"),
  email: z.email("Please provide a valid email address."),
});

export type TermsAndConditionsSchemaType = z.infer<
  typeof termsAndConditionsSchema
>;
export type MobileNumberSchemaType = z.infer<typeof mobileNumberSchema>;
export type MobileNumberVerificationSchemaType = z.infer<
  typeof mobileNumberVerificationSchema
>;
export type NamesAndEmailSchemaType = z.infer<typeof namesAndEmailSchema>;
export type TeamMemberNamesAndEmailSchemaType = z.infer<
  typeof teamMemberNamesAndEmailSchema
>;
